// extracted by mini-css-extract-plugin
module.exports = {"download-icon-list":"style_download-icon-list__OSmwk","textLeft":"style_textLeft__3-bqt"};